import { createStore } from 'satcheljs';
export default createStore('tombstone', {
    folderTombstoneMap: {},
})();
//# sourceMappingURL=Store.js.map